import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CourseTeaserModule } from '../course-teaser';
import { DaLinkModule } from '../da-link';
import { HotelsModule } from '../hotels';
import { TabSectionModule } from '../tab-section';
import { TranslateModule } from '@ngx-translate/core';
import { EventDetailComponent } from './event/event-detail.component';
import { CourseDetailComponent } from './course/course-detail.component';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { SimilarCoursesComponent } from './course/similar-courses/similar-courses.component';
import { CourseCardComponent } from './course/similar-courses/course-card/course-card.component';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { DaButtonModule } from '../da-button/da-button.module';
import { ShowMoreModule } from '../show-more/show-more.module';
import { QRCodeComponent } from 'angularx-qrcode';

@NgModule({
    declarations: [EventDetailComponent, CourseDetailComponent, SimilarCoursesComponent, CourseCardComponent],
    exports: [CourseDetailComponent, EventDetailComponent, CourseCardComponent],
    imports: [
        CommonModule,
        DaButtonModule,
        RouterModule,
        DaProgressiveImageModule,
        CourseTeaserModule,
        TabSectionModule,
        TranslateModule,
        DaLinkModule,
        HotelsModule,
        ShowMoreModule,
        LocalizeRouterModule.forChild([]),
        QRCodeComponent
    ]
})
export class DetailViewModule {}
